import { isArray } from 'lodash';
import { roundOff } from '../../../Components/helper';

export default function useTerminalCalculationHooks() {
  function getWeightedAverageforDifferentColour(inputData, fpSalesUnit) {
    let finalNumber = 0;
    let total = 0;
    inputData.forEach((inputItem) => {
      const salevalue = inputItem?.pricePerUnitLanded ? parseFloat(inputItem.pricePerUnitLanded) : 0;
      const salesUnitValue = fpSalesUnit ? parseFloat(fpSalesUnit) : 0;
      finalNumber += salevalue * salesUnitValue;
      total += salesUnitValue;
    });

    const finalResult = finalNumber / total;
    return !Number.isNaN(finalResult) ? roundOff(finalResult, 2) : 0;
  }

  const landedCalCulation78 = async (level, size, length, landedData, colour, fpSalesUnits) => {
    let landedCost = 0;
    if (level === 6) {
      const landFound = landedData?.filter((landVal) => landVal?.colourway?._id === colour?._id);
      landedCost = getWeightedAverageforDifferentColour(landFound, fpSalesUnits);
    }
    if (level === 7) {
      landedData?.forEach((lanVal) => {
        if (lanVal?.colourway?._id === colour?._id && lanVal?.size === size) {
          landedCost += Number(lanVal.pricePerUnitLanded);
        }
      });

      const landFound = landedData?.filter((landVal) => landVal?.colourway?._id === colour?._id && landVal?.size === size);
      landedCost = getWeightedAverageforDifferentColour(landFound, fpSalesUnits);
    }
    if (level === 8) {
      landedData?.forEach((lanVal) => {
        if (lanVal?.colourway?._id === colour?._id && lanVal?.size === size && lanVal?.length?._id === length?._id) {
          landedCost += Number(lanVal.pricePerUnitLanded);
        }
      });
    }
    return landedCost;
  };

  const landedCalculation = async (landedData, isSizeBreakdown, level, colour, size, length, fpSalesUnits) => {
    let landedCost = 0;
    if (isArray(landedData) && landedData.length > 0) {
      if (isSizeBreakdown) {
        const landFound = landedData.find((landVal) => landVal?.colourway?._id === colour?._id);
        landedCost = Number(landFound?.pricePerUnitLanded) || 1;
      } else {
        landedCost = await landedCalCulation78(level, size, length, landedData, colour, fpSalesUnits);
      }
    } else {
      landedCost = 1;
    }

    return landedCost;
  };

  const calculateTerminal = async (state, level) => {
    let cloneState = state;
    let terminalUnits = 0;
    let totalUKBuyUnits = 0;
    let totalSalesValue = 0;
    let fpSellThrougn = 0;
    let totalSellThrougn = 0;
    let ukRetailCv = 0;
    let ukRetailSvNet = 0;
    let ukRetailSvGross = 0;
    let ukRetailMarginPer = 0;
    let unitsRetail = 0;
    let costRetail = 0;

    let unitsGlobal = 0;
    let costGlobal = 0;
    let unitMOQShortfall = 0;
    let costMOQShortfall = 0;
    const {
      fpSalesUnits,
      mdSalesUnits,
      terminal,
      basicInfo: { moq, colour, size, length },
      vat,
      landedData,
      isSizeBreakdown,
      rrpValue,
    } = cloneState;

    const fpSaleUnit = fpSalesUnits || 0;
    const landedCost = await landedCalculation(landedData, isSizeBreakdown, level, colour, size, length, fpSalesUnits);
    const rrp = rrpValue?.value || 1;
    const MOQ = moq || 1;
    const VAT = vat || 1;
    const mdSaleUnit = mdSalesUnits || 0;
    const terminalValue = terminal?.value || 0;

    terminalUnits = Math.round((Number(fpSaleUnit) + Number(mdSaleUnit)) * (Number(terminalValue) / 100));

    totalUKBuyUnits = Math.round(Number(fpSaleUnit) + Number(mdSaleUnit) + Number(terminalUnits));

    totalSalesValue = roundOff(Number(totalUKBuyUnits) * rrp);
    fpSellThrougn = roundOff((Number(fpSaleUnit) / Number(totalUKBuyUnits)) * 100, 2) || 0;
    totalSellThrougn = roundOff(((Number(fpSaleUnit) + Number(mdSaleUnit)) / Number(totalUKBuyUnits)) * 100) || 0;
    ukRetailCv = roundOff(totalUKBuyUnits * landedCost, 2);
    ukRetailSvGross = roundOff(totalUKBuyUnits * rrp) || 0;
    ukRetailSvNet = roundOff(ukRetailSvGross / (1 + VAT), 2) || 0;

    ukRetailMarginPer = roundOff(((ukRetailSvNet - ukRetailCv) / ukRetailSvNet) * 100, 2) || 0;
    if (isNaN(ukRetailMarginPer) || ukRetailMarginPer === -Infinity || ukRetailMarginPer === Infinity) {
      ukRetailMarginPer = 0;
    }

    // Retail Table Start
    unitsRetail = Math.round(totalUKBuyUnits); // Units Retail =   (Total UK Buy Units)
    costRetail = roundOff(totalUKBuyUnits * landedCost); // Cost Retail =  (Total UK Buy Units * Landed Cost

    // Global Table Start

    unitsGlobal = Math.round(unitsRetail); // Units Global =  (Units APAC+Units EMEA+Units Retail+Units MArket Place+Units Outlet)

    for (const channelKey in state.channels) {
      unitsGlobal += Math.round(Number(state[channelKey]?.unit?.value || 0));
    }
    costGlobal = roundOff(unitsGlobal * landedCost, 2); // Cost Global = Units Global * Landed Cost

    // Short Fall Table Start
    unitMOQShortfall = Math.round(unitsGlobal - MOQ); //  Unit MOQ Shortfall = (Units Global - MOQ)

    costMOQShortfall = roundOff(unitMOQShortfall * landedCost); // Cost MOQ Shortfall = (Unit MOQ Shortfall * Landed cost)

    cloneState = {
      ...cloneState,
      terminalUnits,
      totalUKBuyUnits,
      totalSalesValue,
      fpSellThrougn,
      totalSellThrougn,
      ukRetailCv,
      ukRetailSvNet,
      ukRetailSvGross,
      ukRetailMarginPer,
      unitsRetail, // Units Retail
      costRetail, // Cost Retail
      unitsGlobal, // Units Global
      costGlobal, // Cost Global
      unitMOQShortfall, // Unit MOQ Shortfall
      costMOQShortfall, // Cost MOQ Shortfall
      landedCost,
    };
    return cloneState;
  };

  return { calculateTerminal };
}
